import { React, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import CreateCustomer from "./scenes/pages/CreateCustomer1";
import CustomerList from "./scenes/order/CustomerList1";
import AddProduct from "./scenes/pages/AddProduct";
import TakeOrder from "./scenes/pages/TakeOrder";
import CreateLocation from "./scenes/pages/CreateLocation";
import CreateRoute from "./scenes/pages/CreateRoute";
import AddUser from "./scenes/pages/AddUser";
import Invoice from "./scenes/pages/Invoice";
import OrderList from "./scenes/pages/OrderList";
import ProductList from "./scenes/order/ProductList";
import CustomerMaster from "./scenes/order/CustomerMaster";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import Report from "./scenes/pages/Report";
import Login from "./Login";
import UserList from "./scenes/pages/UserList";
import Locations from "./scenes/pages/Locations";
import RouteList from "./scenes/pages/RouteList";
import CreateItemLoc from "./scenes/pages/CreateItemLoc";
import ItemLocList from "./scenes/pages/ItemLocList";
import UseToken from "./components/UseToken";
import Logout from "./Logout";
import IepaDataGrid from "./components/IepaDataGrid";
import { Pages } from "@mui/icons-material";
import ViewItem from "./scenes/pages/ViewItem";
import LoadList from "./scenes/order/LoadList";
import ViewCustomer from "./scenes/pages/ViewCustomer1";
import ViewUser from "./scenes/pages/ViewUser";
import Delivery from "./scenes/order/Delivery";
import Return from "./scenes/order/Return";
import ReturnOrder from "./scenes/pages/ReturnOrder";
import ViewRoutes from "./scenes/pages/ViewRoutes";
import ViewLocations from "./scenes/pages/ViewLocations";
import CreateItemLocation from "./scenes/pages/CreateItemLocation";
import ViewItemLocation from "./scenes/pages/ViewItemLocation";
import Taxation from "./scenes/pages/Taxation";
import CreateTaxation from "./scenes/pages/CreateTaxation";
import ViewTaxation from "./scenes/pages/ViewTaxation";
import TripSheet from "./scenes/pages/TripSheet";
import LandingPage from "./scenes/order/LandingPage";
import Upload from "./scenes/pages/Upload";
import ViewData from "./scenes/pages/ViewData";
import ViewReport from "./scenes/pages/ViewReport";
import ViewBalance from "./scenes/pages/ViewBalance";
import Collection1 from "./scenes/pages/Collection1";
import Collection2 from "./scenes/pages/Collection2";
import { ModuleProvider } from "./context/ModuleContext";
import ModulesLandingPage from "./scenes/pages/ModulesLandingPage";
import ProfileSetting from "./scenes/pages/ProfileSetting";
import EmployeeProfile from "./scenes/pages/EmployeeProfile";
import Roles from "./scenes/pages/Roles";
import Persona from "./scenes/pages/Persona";
import Inquiry from "./scenes/pages/Inquiry";
import "./global.css";
import CollectionSummary from "./scenes/pages/CollectionSummary";
import Dashboard1 from "./Dashboard1";
import Imex from "./scenes/pages/Imex";
import Configurations from "./scenes/pages/Configurations";
import Tools from "./scenes/pages/Tools";
import EditableGrid from "./scenes/pages/EditableGrid";
import Adapter from "./scenes/pages/Adapter";
import Process from "./scenes/pages/Process";
import Rules from "./scenes/pages/Rules";
import RulesList from "./scenes/pages/RulesList";
import { SearchProvider } from "./context/SearchContext";
import ProcessInquiry from "./scenes/pages/ProcessInquiry";
import RolesList from "./scenes/pages/RolesList";
import Program from "./scenes/pages/ParametersDefinition";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const { token, setToken } = UseToken();

  // console.log("Got the Token::" + token);
  if (!token) {
    return <Login setToken={setToken} />;
  }
  return (
    <ModuleProvider>
      <SearchProvider>
        <ColorModeContext.Provider value={colorMode}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {/* Topbar is now static */}
            <Topbar setIsSidebar={setIsSidebar} />
            <div
              className="app"
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                marginTop: "50px", // Offset to avoid content overlapping Topbar
              }}
            >
              {/* Sidebar placed after the main content to appear on the right */}
              {/*isSidebar && <Sidebar isSidebar={isSidebar} />*/}

              <main
                className="content"
                style={{
                  flexGrow: 1,
                  padding: "20px",
                  minHeight: "calc(100vh - 25px)", // Adjust height to fit with static Topbar
                  backgroundColor: theme.palette.background.default,
                }}
              >
                <Routes>
                  <Route path="/" element={<Login />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/dashboard1" element={<Dashboard1 />} />
                  <Route path="/team" element={<Team />} />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/form" element={<Form />} />
                  <Route path="/bar" element={<Bar />} />
                  <Route path="/pie" element={<Pie />} />
                  <Route path="/line" element={<Line />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/geography" element={<Geography />} />
                  <Route path="/CreateCustomer1" element={<CreateCustomer />} />
                  <Route path="/CustomerList" element={<CustomerList />} />
                  <Route path="/AddProduct" element={<AddProduct />} />
                  <Route path="/TakeOrder" element={<TakeOrder />} />
                  <Route path="/Invoice" element={<Invoice />} />
                  <Route path="/ProductList" element={<ProductList />} />
                  <Route path="/CustomerMaster" element={<CustomerMaster />} />
                  <Route path="/CreateLocation" element={<CreateLocation />} />
                  <Route path="/CreateRoute" element={<CreateRoute />} />
                  <Route path="/AddUser" element={<AddUser />} />
                  <Route path="/Invoice" element={<Invoice />} />
                  <Route path="/OrderList" element={<OrderList />} />
                  <Route path="/Report" element={<Report />} />
                  <Route path="/UserList" element={<UserList />} />
                  <Route path="/Locations" element={<Locations />} />
                  <Route path="/RouteList" element={<RouteList />} />
                  <Route path="/CreateItemLoc" element={<CreateItemLoc />} />
                  <Route path="/ItemLocList" element={<ItemLocList />} />
                  <Route path="/Logout" element={<Logout />} />
                  <Route path="/IepaGrid" element={<IepaDataGrid />} />
                  <Route path="/ViewItem" element={<ViewItem />} />
                  <Route path="/LoadList" element={<LoadList />} />
                  <Route path="/ViewCustomer" element={<ViewCustomer />} />
                  <Route path="/ViewUser" element={<ViewUser />} />
                  <Route path="/Delivery" element={<Delivery />} />
                  <Route path="/Return" element={<Return />} />
                  <Route path="/ReturnOrder" element={<ReturnOrder />} />
                  <Route path="/ViewRoutes" element={<ViewRoutes />} />
                  <Route path="/ViewLocations" element={<ViewLocations />} />
                  <Route
                    path="/CreateItemLocation"
                    element={<CreateItemLocation />}
                  />
                  <Route
                    path="/ViewItemLocation"
                    element={<ViewItemLocation />}
                  />
                  <Route path="/Taxation" element={<Taxation />} />
                  <Route path="/CreateTaxation" element={<CreateTaxation />} />
                  <Route path="/ViewTaxation" element={<ViewTaxation />} />
                  <Route path="/TripSheet" element={<TripSheet />} />
                  <Route path="/LandingPage" element={<LandingPage />} />
                  <Route path="/Upload" element={<Upload />} />
                  <Route
                    path="/view-data/:requestNumber"
                    element={<ViewData />}
                  />
                  <Route path="/ViewData" element={<ViewData />} />
                  <Route path="/ViewReport" element={<ViewReport />} />
                  <Route path="/ViewBalance" element={<ViewBalance />} />
                  <Route path="/Collection1" element={<Collection1 />} />
                  <Route path="/Collection2" element={<Collection2 />} />
                  <Route
                    path="/ModulesLandingPage"
                    element={<ModulesLandingPage />}
                  />
                  <Route path="/ProfileSetting" element={<ProfileSetting />} />
                  <Route
                    path="/EmployeeProfile"
                    element={<EmployeeProfile />}
                  />
                  <Route path="/Roles" element={<Roles />} />
                  <Route path="/Persona" element={<Persona />} />
                  <Route path="/Inquiry" element={<Inquiry />} />
                  <Route
                    path="/CollectionSummary"
                    element={<CollectionSummary />}
                  />
                  <Route path="/Imex" element={<Imex />} />
                  <Route path="/configurations" element={<Configurations />} />
                  <Route path="/tools" element={<Tools />} />
                  <Route path="/EditableGrid" element={<EditableGrid />} />
                  <Route path="/Adapter" element={<Adapter />} />
                  <Route path="/Process" element={<Process />} />
                  <Route path="/Rules" element={<Rules />} />
                  <Route path="/RulesList" element={<RulesList />} />
                  <Route path="/ProcessInquiry" element={<ProcessInquiry />} />
                  <Route path="/RolesList" element={<RolesList />} />
                  <Route path="/ParametersDefinition" element={<Program />} />
                </Routes>
              </main>
            </div>
          </ThemeProvider>
        </ColorModeContext.Provider>
      </SearchProvider>
    </ModuleProvider>
  );
}

export default App;
